import { useRecoilState } from 'recoil';
import { confirmDialogState } from 'state';
import { Dialog } from '@mui/material';

import { DialogTypes } from 'types/types';

import { DeleteConfirmDialog } from './DeleteConfirmDialog';

export function GlobalConfirmDialog() {
  const [dialog, setDialog] = useRecoilState(confirmDialogState);

  return (
    <Dialog
      open={dialog.isOpen ?? false}
      onClose={() => {
        setDialog({
          isOpen: false,
        });
      }}
    >
      {dialog.dialogType === DialogTypes.confirmDelete && (
        <DeleteConfirmDialog />
      )}
    </Dialog>
  );
}
